<template>
  <main class="flex h-full flex-row gap-5">
    <aside
      :class="navCollapsed ? 'w-12' : 'md:w-3/12 lg:w-2/12'"
      class="flex shrink-0 flex-col overflow-hidden rounded-lg bg-white shadow transition-all duration-200"
    >
      <div class="flex shrink-0" :class="navCollapsed ? 'justify-center py-2' : 'justify-end p-1'">
        <button
          type="button"
          class="flex h-6 w-6 items-center justify-center rounded text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
          :title="navCollapsed ? 'Déplier le menu' : 'Replier le menu'"
          @click="navCollapsed = !navCollapsed"
        >
          <FontAwesomeIcon :icon="['fal', navCollapsed ? 'chevron-right' : 'chevron-left']" class="h-3 w-3" />
        </button>
      </div>
      <SettingsNav :collapsed="navCollapsed" />
    </aside>
    <div class="flex-1 min-w-0 flex overflow-hidden rounded bg-white shadow-md">
      <RouterView />
    </div>
  </main>
</template>

<script>
import { mapActions } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import SettingsNav from './nav/TheSaManagementNav.vue'

export default {
  name: 'TheSaManagementPage',
  components: {
    SettingsNav,
    FontAwesomeIcon
  },
  data() {
    return {
      navCollapsed: false
    }
  },
  methods: {
    ...mapActions('sideMenu', ['collapse'])
  }
}
</script>
